export default __webpack_public_path__ + "assets/images/67b9b6d33a86a98f06f8525c87d27af6.webp";